import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import get from 'lodash/get';
import baseActions from '../actions';
import PreFlightOptimisationModal from '../components/PreFlightOptimisationModal';
import {
  PRE_FLIGHT_DATA,
  NON_MAINTAINED_SHIFT_COUNT,
  CONFIG
} from '../plannerConfig';
const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  loading: state[PRE_FLIGHT_DATA].loadingQueue.length > 0,
  preflightCheckProps: {
    ...ownProps.preflightCheckProps,
    timeZone: get(state[CONFIG].data, 'timeZone'),
    nonMaintainedShiftCount: get(state[PRE_FLIGHT_DATA].data, 'nonMaintainedShiftCount', 0),
    syncsInProgress: get(state[PRE_FLIGHT_DATA].data, 'syncsInProgress', {}),
    // [PRE_FLIGHT_DATA]: get(state[PRE_FLIGHT_DATA].data, 'nonMaintainedShiftCount', 0),
  },
});
const mapDispatchToProps = {
  get: baseActions.get,
};
const getStartDate = (startDate, timeZone) => {
  const dateString = startDate.format('YYYY-MM-DD HH:mm');
  return moment.tz(dateString, timeZone).toISOString();
};
class PreFlightOptimisationModalContainer extends Component {
  componentDidMount() {
    const { get: apiGet, preflightCheckProps } = this.props;
    const {
      scenario, startOfWeekDate, endOfWeekDate, optimisationOptions: { startTime }, timeZone
    } = preflightCheckProps;
    const preFlightDataQueryParams = {
      scenario,
      startDate: startTime ? getStartDate(startTime, timeZone) : startOfWeekDate,
      endDate: endOfWeekDate,
    };
    apiGet([PRE_FLIGHT_DATA], { routeParams: preFlightDataQueryParams });
  }
  startOptimisation = () => {
    const { onSubmit, preflightCheckProps: { optimisationOptions: { startTime }, timeZone } } = this.props;
    const startDateTime = startTime ? getStartDate(startTime, timeZone) : undefined;
    onSubmit(startDateTime);
  }
  render() {
    return <PreFlightOptimisationModal {...this.props} onSubmit={this.startOptimisation} />;
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreFlightOptimisationModalContainer);
